/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputChatFile
 */
export interface OutputChatFile {
    /**
     * 
     * @type {number}
     * @memberof OutputChatFile
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof OutputChatFile
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputChatFile
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof OutputChatFile
     */
    width: number;
}

/**
 * Check if a given object implements the OutputChatFile interface.
 */
export function instanceOfOutputChatFile(value: object): boolean {
    if (!('height' in value)) return false;
    if (!('id' in value)) return false;
    if (!('type' in value)) return false;
    if (!('width' in value)) return false;
    return true;
}

export function OutputChatFileFromJSON(json: any): OutputChatFile {
    return OutputChatFileFromJSONTyped(json, false);
}

export function OutputChatFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputChatFile {
    if (json == null) {
        return json;
    }
    return {
        
        'height': json['height'],
        'id': json['id'],
        'type': json['type'],
        'width': json['width'],
    };
}

export function OutputChatFileToJSON(value?: OutputChatFile | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'height': value['height'],
        'id': value['id'],
        'type': value['type'],
        'width': value['width'],
    };
}

